import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { getStepIndex, REIMBURSEMENT_STEPS } from '../steps';
import type { ReimbursementStepId } from '../types';

export function ReimbursementStepper({ currentStep }: { currentStep: ReimbursementStepId }): ReactElement {
    const { t } = useTranslation();
    const theme = useTheme();
    const isCompact = useMediaQuery(theme.breakpoints.down('sm'));
    const activeStep = getStepIndex(currentStep);

    if (isCompact) {
        return (
            <Typography variant="body2" color="text.secondary">
                {t('REIMBURSEMENT.STEP_COUNTER', {
                    current: activeStep + 1,
                    total: REIMBURSEMENT_STEPS.length,
                    label: t(REIMBURSEMENT_STEPS[activeStep].labelKey),
                })}
            </Typography>
        );
    }

    return (
        <Stepper activeStep={activeStep} sx={{ flex: 1 }}>
            {REIMBURSEMENT_STEPS.map((step) => (
                <Step key={step.id}>
                    <StepLabel>{t(step.labelKey)}</StepLabel>
                </Step>
            ))}
        </Stepper>
    );
}
